import { AccessLog } from './AccessLog'
import { Article } from './Article'
import { Classification } from './Classification'
import { Document } from './Document'
import { HealthElement } from './HealthElement'
import { Invoice } from './Invoice'
import { Form } from './Form'
import { Contact } from './Contact'
import { CalendarItem } from './CalendarItem'
import { MaintenanceTask } from './MaintenanceTask'
import { Message } from './Message'
import { Receipt } from './Receipt'
import { RelatedPerson } from './RelatedPerson'
import { Patient } from './Patient'
import { Delegation } from './Delegation'
import { SecurityMetadata } from './SecurityMetadata'
import { IcureStub } from './IcureStub'
import { Topic } from './Topic'
import { ApplicationSettings } from './ApplicationSettings'

export * from './AbstractFilterCode'
export * from './AbstractFilterContact'
export * from './AbstractFilterDevice'
export * from './AbstractFilterHealthElement'
export * from './AbstractFilterHealthcareParty'
export * from './AbstractFilterInvoice'
export * from './AbstractFilterMaintenanceTask'
export * from './AbstractFilterPatient'
export * from './AbstractFilterRelatedPerson'
export * from './AbstractFilterService'
export * from './AbstractFilterUser'
export * from './AccessLog'
export * from './AddedDocument'
export * from './Address'
export * from './AdministrationQuantity'
export * from './Agenda'
export * from './AgreementAppendix'
export * from './Amp'
export * from './AmpComponent'
export * from './Ampp'
export * from './AmppComponent'
export * from './Annotation'
export * from './ApplicationSettings'
export * from './AppointmentTypeAndPlace'
export * from './Article'
export * from './Atc'
export * from './AttachmentMetadata'
export * from './AuthenticationResponse'
export * from './AuthenticationToken'
export * from './Basic'
export * from './Body'
export * from './BulkAttachmentUpdateOptions'
export * from './CalendarItem'
export * from './CalendarItemTag'
export * from './CalendarItemType'
export * from './CareTeamMember'
export * from './CareTeamMembership'
export * from './CheckSMFPatientResult'
export * from './Classification'
export * from './ClassificationTemplate'
export * from './Code'
export * from './CodeStub'
export * from './CodeType'
export * from './CommentedClassification'
export * from './Commercialization'
export * from './Company'
export * from './ConflictResolutionRequest'
export * from './ConflictResolutionResult'
export * from './ConflictResolutionStrategy'
export * from './Contact'
export * from './ContactParticipant'
export * from './Content'
export * from './Copayment'
export * from './CryptoActorStub'
export * from './Data'
export * from './DataAttachment'
export * from './DataOwnerRegistrationSuccess'
export * from './DataOwnerTypeEnum'
export * from './DataOwnerWithType'
export * from './DatabaseInfo'
export * from './DatabaseInitialisation'
export * from './DatabaseSynchronization'
export * from './Delegation'
export * from './DeletedAttachment'
export * from './Device'
export * from './DeviceType'
export * from './DiaryNoteExportInfo'
export * from './Dmpp'
export * from './DocIdentifier'
export * from './Document'
export * from './DocumentGroup'
export * from './DocumentTemplate'
export * from './Duration'
export * from './EIDItem'
export * from './Editor'
export * from './EfactInvoice'
export * from './Employer'
export * from './EmploymentInfo'
export * from './EntityReference'
export * from './EntityTemplate'
export * from './Episode'
export * from './FilterChainCode'
export * from './FilterChainContact'
export * from './FilterChainDevice'
export * from './FilterChainHealthElement'
export * from './FilterChainHealthcareParty'
export * from './FilterChainInvoice'
export * from './FilterChainMaintenanceTask'
export * from './FilterChainPatient'
export * from './FilterChainRelatedPerson'
export * from './FilterChainService'
export * from './FilterChainUser'
export * from './FinancialInstitutionInformation'
export * from './FlatRateTarification'
export * from './FlowItem'
export * from './Form'
export * from './FormColumn'
export * from './FormDataOption'
export * from './FormLayout'
export * from './FormLayoutData'
export * from './FormPlanning'
export * from './FormSection'
export * from './FormTemplate'
export * from './FormTemplateLayout'
export * from './Formula'
export * from './FrontEndMigration'
export * from './Group'
export * from './GroupDatabasesInfo'
export * from './GuiCode'
export * from './GuiCodeType'
export * from './GroupDeletionReport'
export * from './HealthElement'
export * from './HealthElementAsserter'
export * from './HealthElementQualifiedLink'
export * from './HealthcareParty'
export * from './HealthcarePartyHistoryStatus'
export * from './IcureStub'
export * from './IdWithRev'
export * from './Identifier'
export * from './IdentityDocumentReader'
export * from './ImportMapping'
export * from './ImportResult'
export * from './IncapacityExportInfo'
export * from './IndexingInfo'
export * from './Ingredient'
export * from './Insurability'
export * from './Insurance'
export * from './Invoice'
export * from './InvoiceItem'
export * from './InvoiceSender'
export * from './InvoicesBatch'
export * from './InvoicingCode'
export * from './Keyword'
export * from './KeywordSubword'
export * from './LabelledOccurence'
export * from './LetterValue'
export * from './ListOfIds'
export * from './ListOfProperties'
export * from './LoginCredentials'
export * from './MaintenanceTask'
export * from './MapOfIds'
export * from './Measure'
export * from './MedexInfo'
export * from './MedicalHouseContract'
export * from './MedicalLocation'
export * from './Medication'
export * from './MedicationSchemeExportInfo'
export * from './Medicinalproduct'
export * from './MergeResult'
export * from './Message'
export * from './MessageAttachment'
export * from './MessageReadStatus'
export * from './MessageWithBatch'
export * from './MessagesReadStatusUpdate'
export * from './MimeAttachment'
export * from './Nmp'
export * from './NoGenericPrescriptionReason'
export * from './NoSwitchReason'
export * from './NumeratorRange'
export * from './PackagingType'
export * from './PaginatedDocumentKeyIdPairObject'
export * from './PaginatedListAccessLog'
export * from './PaginatedListAmp'
export * from './PaginatedListClassification'
export * from './PaginatedListClassificationTemplate'
export * from './PaginatedListCode'
export * from './PaginatedListContact'
export * from './PaginatedListDevice'
export * from './PaginatedListDocument'
export * from './PaginatedListEntityTemplate'
export * from './PaginatedListForm'
export * from './PaginatedListGroup'
export * from './PaginatedListHealthcareParty'
export * from './PaginatedListHealthElement'
export * from './PaginatedListInsurance'
export * from './PaginatedListInvoice'
export * from './PaginatedListMaintenanceTask'
export * from './PaginatedListMedicalLocation'
export * from './PaginatedListMessage'
export * from './PaginatedListNmp'
export * from './PaginatedListPatient'
export * from './PaginatedListRelatedPerson'
export * from './PaginatedListService'
export * from './PaginatedListString'
export * from './PaginatedListTarification'
export * from './PaginatedListTopic'
export * from './PaginatedListUser'
export * from './PaginatedListVmp'
export * from './PaginatedListVmpGroup'
export * from './Paragraph'
export * from './ParagraphAgreement'
export * from './Part'
export * from './Partnership'
export * from './Patient'
export * from './PatientHealthCareParty'
export * from './Payment'
export * from './Periodicity'
export * from './Permission'
export * from './PermissionItem'
export * from './PersonName'
export * from './PharmaceuticalForm'
export * from './PharmaceuticalFormStub'
export * from './Place'
export * from './PlanOfAction'
export * from './Predicate'
export * from './Pricing'
export * from './PropertyStub'
export * from './PropertyTypeStub'
export * from './PublicKey'
export * from './Quantity'
export * from './Range'
export * from './Receipt'
export * from './ReferenceRange'
export * from './ReferralPeriod'
export * from './RegimenItem'
export * from './RegistrationInformation'
export * from './RegistrationSuccess'
export * from './Reimbursement'
export * from './ReimbursementCriterion'
export * from './RelatedPerson'
export * from './Remote'
export * from './RemoteAuthentication'
export * from './Renewal'
export * from './Replication'
export * from './ReplicateCommand'
export * from './ReplicationInfo'
export * from './ReplicationStats'
export * from './ReplicatorDocument'
export * from './ReplicatorResponse'
export * from './ResultInfo'
export * from './Right'
export * from './Role'
export * from './RoleConfiguration'
export * from './RoleSourceEnum'
export * from './RouteOfAdministration'
export * from './SamText'
export * from './SamVersion'
export * from './SchoolingInfo'
export * from './Section'
export * from './Service'
export * from './ServiceLink'
export * from './SoftwareMedicalFileExport'
export * from './StandardSubstance'
export * from './StrengthRange'
export * from './StructureElement'
export * from './SubContact'
export * from './Substance'
export * from './SubstanceStub'
export * from './Substanceproduct'
export * from './Suggest'
export * from './SumehrContent'
export * from './SumehrExportInfo'
export * from './SumehrValidity'
export * from './SupplyProblem'
export * from './Suspension'
export * from './Tag'
export * from './Tarification'
export * from './Telecom'
export * from './TimeSeries'
export * from './TimeTable'
export * from './TimingInfo'
export * from './TimeTableHour'
export * from './TimeTableItem'
export * from './TokenWithGroup'
export * from './TypedValueObject'
export * from './Unit'
export * from './User'
export * from './UserAndHealthcareParty'
export * from './UserGroup'
export * from './UserTypeEnum'
export * from './Valorisation'
export * from './Verse'
export * from './VirtualForm'
export * from './VirtualIngredient'
export * from './Vmp'
export * from './VmpComponent'
export * from './VmpGroup'
export * from './VmpGroupStub'
export * from './VmpStub'
export * from './Vtm'
export * from './Wada'
export * from './Weekday'
export * from './SecurityMetadata'
export * from './SecureDelegation'
export * from './Topic'
export * from './Connection'
export * from './ISO639_1'

export type EncryptedEntity =
  | AccessLog
  | ApplicationSettings
  | Article
  | CalendarItem
  | Classification
  | Contact
  | Document
  | Form
  | HealthElement
  | Invoice
  | MaintenanceTask
  | Message
  | Patient
  | Receipt
  | RelatedPerson
  | Topic

export type EncryptedEntityStub =
  | {
      // When changing remember to also update icc-x-api/crypto/utils/encryptedStubEquals
      id?: string
      secretForeignKeys?: Array<string>
      cryptedForeignKeys?: { [key: string]: Delegation[] }
      delegations?: { [key: string]: Delegation[] }
      encryptionKeys?: { [key: string]: Delegation[] }
      encryptedSelf?: string
      securityMetadata?: SecurityMetadata
    }
  | IcureStub

export type EncryptedParentEntity = Message | Patient
